module.exports = __webpack_public_path__ + "img/video-bg-img.dc149955.png";